import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/pro-light-svg-icons";

const MenuIcon = ({ className = "", ...rest }) => {
  return <FontAwesomeIcon icon={faBars} {...rest} className={className} />;
};

export default MenuIcon;
